import React from 'react';
import './App.css';
import Game from './Game'
import Edward from './Edward Naidoo Headshot Resized Low res.jpg'

function NavBar() {
  return (
    <>
      <header>
        <div id="home">
          <ul><li><a href="#home">Test Your Booksmarts!</a></li></ul>
        </div>
        <div className="links">
          <ul><li><a href="#Quiz">Quiz</a></li></ul>
          <ul><li><a href="#aboutme">About Me</a></li></ul>
        </div>
      </header>
    </>
  );
}

function Greetings() {
  return (
    <>
      <div className="greetings__background">
        <p>
          Thank you in advance for showing your intrest in my English 12 Project 
          to end of my semester! This is a quiz for the book 'The Giver'.
        </p>
      </div>
    </>
  );
}


function AboutMe() {
  return (
    <div id='aboutme'>
      <div id='title'><h1>About Me</h1></div>
      <div className="block">

        <div className="headshot">
          <img src={Edward} alt='Edwards Headshot' />
        </div>
        <div className="combined__text">
          <div className="text">
            Once again, welcome! This website
            is to complete my final project for English 12.
          </div>

          <div className="text">
            My name is Edward Naidoo and I am based in
            British Columbia, Canada. I like to draw and run,
            but with covid raging, drawing is what I do anyways.
            I have been making 3D objects in Blender to compensate
            the lack of drawings. I hope this site helps you learn
            about the book.
          </div>
        </div>
      </div>
    </div>
  );
}

function Body() {
  return (
    <>
      <Greetings />
      <div id='Quiz'>
        <Game />
      </div>
      <AboutMe />
    </>
  );
}

function Footer() {
  return (
    <footer>
      <div className="footer__social">
        <ul><li><a href="https://twitter.com/EWNaidoo">Twitter</a></li></ul>
        <ul><li><a href="https://github.com/H12M54AM">GitHub</a></li></ul>
        <ul><li><a href="https://www.linkedin.com/in/edward-naidoo-595ab5224/">LinkedIn</a></li></ul>
      </div>
      {/* <div id="copyright">
        @copyright 2022
      </div> */}
      <div id="credits">Made by Edward Naidoo</div>
    </footer>
  )
}

function App() {
  return (
    <>
      <NavBar />
      <Body />
      <Footer />
    </>
  );
}

export default App;